import axios from 'axios';
import Checkbox from '../../components/checkbox/checkbox';
import SearchBox from '../../components/searchBox/searchBox';

import ManagementSolutionDialog from '../../components/managementSolutionDialog/managementSolutionDialog';

const queryString = require('query-string');

class ManagementSolutions {
    constructor(el) {
        this.el = el;

        const searchBoxElement = document.querySelector('.searchBox');

        if (searchBoxElement) {
            this.searchBox = new SearchBox(searchBoxElement);
        }

        this.currentSearch = '';

        this.dialog = new ManagementSolutionDialog();

        this.state = {
            currentFilter: 'all',
            activeTermBox: null,
            items: [],
            openIndex: null
        };

        this.showAllButton = document.querySelector(
            '.managementSolutions__loadMoreholder .button'
        );

        this.bindEvents();
    }

    bindEvents() {
        if (this.showAllButton) { // För kompabilitet med visning på sida enskilda produkter
            this.showAllButton.addEventListener('click', () => this.showAllItems());
        }
        if (this.searchBox) {
            this.searchBox.on('search', (value) => this.searchHandler(value));
        }
    }

    showAllItems() {
        this.hideShowAllButton();

        let hiddenCards = document.querySelectorAll(
            '.hiddenOnLoad'
        );

        for (let i = 0; i < hiddenCards.length; i++) {
            hiddenCards[i].classList.remove('hiddenOnLoad');
        }
    }

    hideShowAllButton() {
        if (this.showAllButton) {
            this.showAllButton.parentNode.style.display = 'none';
        }
    }

    showShowAllButton() {
        this.showAllButton.parentNode.style.display = 'block';
    }

    initArchive() {
        const filters = this.el.querySelectorAll('.checkbox');

        this.checkboxes = [];
        this.itemsEl = this.el.querySelector('.managementSolutions__items');

        this.items = [];

        this.dialog.on('updateUrl', openIndex => {
            this.state.openIndex = openIndex;
            this.updateUrl();
        });

        for (let i = 0; i < filters.length; i++) {
            const checkbox = new Checkbox(filters[i]);
            this.checkboxes.push(checkbox);
            checkbox.on('changed', () => this.filterChanged(checkbox));
        }

        this.setFiltersFromUrl();
        this.loadItems();
    }

    setItems(items) {
        this.state.items = items;
        this.dialog.setItems(items);
    }

    setFiltersFromUrl() {
        const parsed = queryString.parse(window.location.search);

        if (parsed.filters) {
            this.state.currentFilter = parsed.filters;
            this.setFiltersFromState();
            this.setActiveTermBox();
        }
    }

    setActiveTermBox() {
        if (this.state.activeTermBox) {
            this.state.activeTermBox.style.display = 'none';
        }

        if (this.state.currentFilter === 'all') {
            return;
        }

        this.state.activeTermBox = this.el.querySelector(
            `.managementSolutionsTermBox[data-id="${this.state.currentFilter}"]`
        );

        if (this.state.activeTermBox) {
            this.state.activeTermBox.style.display = 'block';
        }
    }

    filterChanged(checkbox) {
        if (checkbox.id === this.state.currentFilter) {
            this.state.currentFilter = 'all';
        } else {
            this.state.currentFilter = checkbox.id;
        }

        this.setFiltersFromState();
        this.setActiveTermBox();
        this.updateUrl();
        this.render();
    }

    setFiltersFromState() {
        for (let i = 0; i < this.checkboxes.length; i++) {
            const checkbox = this.checkboxes[i];
            if (this.state.currentFilter !== checkbox.id) {
                checkbox.setInactive();
            } else {
                checkbox.setActive();
            }
        }
    }

    searchHandler(keyword) {
        if (keyword.length > 2) {
            this.currentSearch = keyword;
            this.render();
        } else if (this.currentSearch !== '') {
            this.currentSearch = '';
            this.render();
        }
    }

    updateUrl() {
        const hasFilters = this.state.currentFilter !== 'all';
        let newString = '';

        if (hasFilters) {
            newString += '?filters=' + this.state.currentFilter;
        }

        if (hasFilters && this.state.openIndex !== null) {
            newString += '&';
        } else if (!hasFilters && this.state.openIndex !== null) {
            newString += '?';
        }

        if (this.state.openIndex !== null) {
            newString += 'open=' + this.state.openIndex;
        }

        window.history.replaceState(
            null,
            '',
            window.location.href.split('?')[0] + (newString || '')
        );
    }

    getFilteredItems() {
        if (this.state.currentFilter === 'all') {
            return this.items;
        }

        return this.items.filter(item => {
            if (!item.categories) {
                return false;
            }

            return item.categories.find(
                category => this.state.currentFilter === category.slug
            );
        });
    }

    searchItems(items) {
        if (this.currentSearch === '') {
            return items;
        }

        return items.filter(item => {
            if (item.title.toLowerCase().substring(0, this.currentSearch.length) === this.currentSearch) {
                return true;
            }
            if (item.id.toString().substring(0, this.currentSearch.length) === this.currentSearch) {
                return true;
            }
            for (let i = 0; i < item.productTitles.length; i++) {
                if (item.productTitles[i].toLowerCase().substring(0, this.currentSearch.length) === this.currentSearch) {
                    return true;
                }
            }
            return false;
        });
    }

    loadItems() {
        axios
            .get('/management-solutions')
            .then(response => {
                this.items = response.data;
                this.render();
            })
            .catch(error => {
                console.log(error);
            });
    }

    render() {
        let items = this.getFilteredItems();

        items = this.searchItems(items);

        this.state.items = items;
        this.dialog.setItems(items);

        let html = '';

        for (let i = 0; i < items.length; i++) {
            html += this.getHtmlForItem(items[i], i);
        }

        this.itemsEl.innerHTML = html;

        if (items.length > 12) {
            this.showShowAllButton();
        }

        this.dialog.checkForOpenItem();
    }

    open(index) {
        this.dialog.open(index);
    }

    getHtmlForItem(item, index) {
        let categories = '';
        if (item.categories) {
            categories = item.categories
                .map(category => category.name)
                .join(', ');
        }
        let hiddenOnLoad = '';
        if (index > 11) {
            hiddenOnLoad = ' hiddenOnLoad';
        }
        let hasVideoClass = '';
        if (item.has_video) {
            hasVideoClass = 'has_video';
        }

        return `
            <div class="managementSolutions__column${hiddenOnLoad}">
                <div
                    onclick="managementSolutions.open(${index})"
                    class="managementSolutionCard ${hasVideoClass}"
                >
                    <div class="managementSolutionCard__imageHolder">
                        <img
                            src="${item.image.sizes.medium_large}"
                            alt="${item.image.alt}"
                            class="managementSolutionCard__image ab100 objectFitCover"
                        >
                        <div class="managementSolutionCard__overlay ab100">
                            <div class="managementSolutionCard__overlayInner">
                                <div class="managementSolutionCard__overlayIcon"></div>
                                <div class="managementSolutionCard__overlayLabel">
                                    ${window.translations.readMore}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="managementSolutionCard__textHolder">
                        <div class="managementSolutionCard__textHolderInner">
                            <h3 class="managementSolutionCard__title">
                                ${item.title}
                            </h3>

                            <p class="managementSolutionCard__categories">
                                ${categories}
                            </p>

                            <p class="managementSolutionCard__id">
                                #${item.id}
                            </p>
                        </div>

                        <div class="managementSolutionCard__gradient ab100"></div>
                    </div>
                </div>
            </div>
        `;
    }
}
let el = document.querySelector('.managementSolutions');
let managementSolutions = null;

if (!el) {
    el = document.querySelector('.productSolutions__columns');
}

if (el) {
    managementSolutions = new ManagementSolutions(el);
    window.managementSolutions = managementSolutions;
}

export default managementSolutions;



// WEBPACK FOOTER //
// ./src/pages/managementSolutions/managementSolutions.js